import styled from 'styled-components';
import {Upload, Select,Input, Form } from 'antd';

export const Container = styled.div`
  background: #fff;
  border-radius: 4px;
  width: 100%;
`;

export const FormTitle = styled.div`
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 20px;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  td {
    border: 1px solid #d9d9d9;
    padding: 8px;
    font-size: 13px;
    vertical-align: middle;
  }

  td:first-child {
    background-color: #f5f5f5;
    font-size: 13px;
    font-weight: 500;
    height: 45px;
    vertical-align: middle;
    border-left: none;
    min-width: 110px;
  }

  td:last-child {
    border-right: none;
    width: 75%;
  }
`;

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledInput = styled(Input)`
  border-radius: 4px;
  width: 70%;
`;

export const StyledSelect = styled(Select)`
`;

export const StyledUpload = styled(Upload)`
  .ant-upload {
    width: 70%;
  }
`;

export const FileName = styled.div`
  margin-left: 8px;
  color: gray;
`;

export const StyledFormItem = styled(Form.Item)`
  margin-bottom: 0;

  .ant-form-item {
    margin: none;
  }

  .ant-form-item-control-input-content {
    display: flex;
    align-items: center;
  }

  &.ant-form-item {
    padding: 0;
  }

  .ant-form-item-control {
    border: none;
  }
`;